import React from 'react';
import classNames from 'classnames/bind';

import { Camera } from 'types/camera';
import { Stream } from 'types/stream';

import { Icon } from 'components/Icon/IconDeprecated';
import { StatusIndicator } from 'components/StatusIndicator/StatusIndicator';
import { TagSelect } from 'tags/components/TagSelect/TagSelect';
import { Text } from 'components/Text/Text';

import { getVideoSourceDisplayInfo } from './get_display_info';
import { getVideoSourceIcon } from './get_icon';
import styles from './VideoSourceSelect.module.scss';

const c = classNames.bind(styles);

export type ItemProps = {
  item: Camera | Stream;
  active: boolean;
};

function VideoSourceSelectItem(
  { item, active, ...props }: ItemProps,
  ref: React.ForwardedRef<HTMLLIElement>
) {
  const { status, tags } = item;
  const info = getVideoSourceDisplayInfo(item);

  return (
    <li {...props} className={c('suggestion-item', { active })} ref={ref}>
      {!('stream_type' in item && item.stream_type === 'file') && (
        <StatusIndicator
          className={c('suggestion-item-status')}
          status={status}
          size="small"
        />
      )}

      <Icon
        className={c('suggestion-item-icon')}
        name={getVideoSourceIcon(item)}
      />

      <Text className={c('suggestion-item-name')} inline>
        {item.name ?? String(item.id)}
      </Text>

      {info && (
        <Text className={c('suggestion-item-info')} size="small" inline>
          {info}
        </Text>
      )}

      {tags.length > 0 && (
        <div className={c('suggestion-item-tags')}>
          <TagSelect defaultValue={tags} readOnly />
        </div>
      )}
    </li>
  );
}

const forwardedRef = React.forwardRef(VideoSourceSelectItem);

export { forwardedRef as VideoSourceSelectItem };
